import _asyncToGenerator from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { disconnect as a, getAccount as l, watchAccount as h, fetchBalance as d, getNetwork as w, watchNetwork as u, switchNetwork as C, fetchEnsName as g, fetchEnsAvatar as p, connect as s, InjectedConnector as f } from "@wagmi/core";
import { WalletConnectConnector as m } from "@wagmi/connectors/walletConnect";
import { WalletConnectLegacyConnector as y } from "@wagmi/core/connectors/walletConnectLegacy";
import { jsonRpcProvider as v } from "@wagmi/core/providers/jsonRpc";

var A = /*#__PURE__*/function () {
  function A(t, n) {
    _classCallCheck(this, A);

    this.wagmi = {}, this.walletConnectVersion = 1, this.chains = [], this.namespace = "eip155", this.disconnect = a, this.getAccount = l, this.watchAccount = h, this.fetchBalance = d, this.getNetwork = w, this.watchNetwork = u, this.switchNetwork = C, this.fetchEnsName = g, this.fetchEnsAvatar = p, this.wagmi = t, this.chains = n;

    var _this$getWalletConnec = this.getWalletConnectConnectors(),
        e = _this$getWalletConnec.isV2;

    this.walletConnectVersion = e ? 2 : 1;
  }

  _createClass(A, [{
    key: "getWalletConnectConnectors",
    value: function getWalletConnectConnectors() {
      var t = this.wagmi.connectors.find(function (c) {
        return c.id === "walletConnect";
      }),
          n = this.wagmi.connectors.find(function (c) {
        return c.id === "walletConnectLegacy";
      }),
          e = t !== null && t !== void 0 ? t : n;
      if (!e) throw new Error("WalletConnectConnector or WalletConnectLegacyConnector is required");
      return {
        isV2: !!t,
        connector: e
      };
    }
  }, {
    key: "connectWalletConnectV1",
    value: function () {
      var _connectWalletConnectV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(t, n) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (e, c) {
                  t.once("message", /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
                      var i, r;
                      return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              i = _ref.type;

                              if (!(i === "connecting")) {
                                _context.next = 6;
                                break;
                              }

                              _context.next = 4;
                              return t.getProvider();

                            case 4:
                              r = _context.sent.connector;
                              n(r.uri), r.on("disconnect", function () {
                                c(Error());
                              }), r.on("connect", function () {
                                e();
                              });

                            case 6:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function connectWalletConnectV1(_x, _x2) {
        return _connectWalletConnectV.apply(this, arguments);
      }

      return connectWalletConnectV1;
    }()
  }, {
    key: "connectWalletConnectV2",
    value: function () {
      var _connectWalletConnectV2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(t, n) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return t.getProvider();

              case 2:
                return _context3.abrupt("return", new Promise(function (e) {
                  t.once("message", function (c) {
                    c.type === "display_uri" && (n(c.data), e());
                  });
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function connectWalletConnectV2(_x4, _x5) {
        return _connectWalletConnectV2.apply(this, arguments);
      }

      return connectWalletConnectV2;
    }()
  }, {
    key: "getConnectorById",
    value: function getConnectorById(t) {
      var n = this.wagmi.connectors.find(function (e) {
        return e.id === t;
      });
      if (!n) throw new Error("Connector for id ".concat(t, " was not found"));
      return n;
    }
  }, {
    key: "getConnectors",
    value: function getConnectors() {
      return this.wagmi.connectors.filter(function (t) {
        return !t.id.includes("walletConnect");
      });
    }
  }, {
    key: "connectWalletConnect",
    value: function () {
      var _connectWalletConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(t, n) {
        var _this$getWalletConnec2, e, c, i, r;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$getWalletConnec2 = this.getWalletConnectConnectors(), e = _this$getWalletConnec2.connector, c = _this$getWalletConnec2.isV2, i = {
                  connector: e
                };
                n && (i.chainId = n);
                r = c ? this.connectWalletConnectV2.bind(this) : this.connectWalletConnectV1.bind(this);
                return _context4.abrupt("return", Promise.all([s(i), r(e, t)]));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function connectWalletConnect(_x6, _x7) {
        return _connectWalletConnect.apply(this, arguments);
      }

      return connectWalletConnect;
    }()
  }, {
    key: "connectConnector",
    value: function () {
      var _connectConnector = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(t, n) {
        var e;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                e = {
                  connector: this.getConnectorById(t)
                };
                n && (e.chainId = n);
                _context5.next = 4;
                return s(e);

              case 4:
                return _context5.abrupt("return", _context5.sent);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function connectConnector(_x8, _x9) {
        return _connectConnector.apply(this, arguments);
      }

      return connectConnector;
    }()
  }, {
    key: "isInjectedProviderInstalled",
    value: function isInjectedProviderInstalled() {
      return typeof window.ethereum < "u";
    }
  }, {
    key: "safeCheckInjectedProvider",
    value: function safeCheckInjectedProvider(t) {
      var n;

      try {
        var e = String(t);
        return !!((n = window.ethereum) != null && n[e]);
      } catch (e) {
        return console.error(e), !1;
      }
    }
  }, {
    key: "pingWalletConnect",
    value: function () {
      var _pingWalletConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this$getWalletConnec3, t, n, e, c;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _this$getWalletConnec3 = this.getWalletConnectConnectors();
                t = _this$getWalletConnec3.connector;
                _context6.next = 5;
                return t.getProvider();

              case 5:
                n = _context6.sent;
                e = n.signer.client.pairing.getAll();
                c = e[e.length - 1].topic;
                n.signer.client.ping({
                  topic: c
                });
                _context6.next = 14;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);
                console.info(_context6.t0);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 11]]);
      }));

      function pingWalletConnect() {
        return _pingWalletConnect.apply(this, arguments);
      }

      return pingWalletConnect;
    }()
  }]);

  return A;
}();

var W = "eip155";

function N(_ref3) {
  var o = _ref3.projectId;
  return v({
    rpc: function rpc(t) {
      var n;
      return [1, 3, 4, 5, 10, 42, 56, 69, 97, 100, 137, 280, 324, 420, 42161, 42220, 43114, 80001, 421611, 421613, 1313161554, 1313161555].includes(t.id) ? {
        http: "https://rpc.walletconnect.com/v1/?chainId=".concat(W, ":").concat(t.id, "&projectId=").concat(o)
      } : {
        http: t.rpcUrls.default.http[0],
        webSocket: (n = t.rpcUrls.default.webSocket) == null ? void 0 : n[0]
      };
    }
  });
}

function V(_ref4) {
  var o = _ref4.chains,
      t = _ref4.version,
      n = _ref4.projectId;
  var e = t === 1,
      c = [new f({
    chains: o
  })];
  return e ? c.unshift(new y({
    chains: o,
    options: {
      qrcode: !1
    }
  })) : c.unshift(new m({
    chains: o,
    options: {
      projectId: n,
      showQrModal: !1
    }
  })), c;
}

export { A as EthereumClient, V as w3mConnectors, N as w3mProvider };